module.exports = __webpack_public_path__ + "static/media/financi.co.92d73ac2.png";